import React from "react";
import { NavLink } from "react-router-dom";
import { useState } from "react";
import EnquiryModal from "./Enquiry";
const Header = () => {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      {/* ========== TOP BAR (Hidden on Mobile) ========== */}
      <div
        className="py-2 border-bottom d-none d-md-block"
        style={{
          backgroundColor: "var(--color-text-primary)",
          color: "#fff",
          borderColor: "var(--color-warning)",
          fontSize: "0.85rem",
        }}
      >
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex gap-3">
              <span>
                <i className="bi bi-patch-check-fill me-1 text-warning" />
                FSSAI Certified · ISO 22000
              </span>

              <span>
                <i className="bi bi-truck me-1 text-warning" />
                PAN India Supply
              </span>
            </div>

            <div className="d-flex gap-3">
              <span>
                <i className="bi bi-envelope-fill me-1 text-warning" />
                hindustanfruits@yahoo.co.in
              </span>

              <span>
                <i className="bi bi-telephone-fill me-1 text-warning" />
                +91 9431812596
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* ========== NAVBAR ========== */}
      <nav
        className="navbar navbar-expand-lg py-3 shadow-sm sticky-top"
        style={{
          backgroundColor: "var(--color-surface)",
          zIndex: 999,
        }}
      >
        <div className="container">
          {/* LOGO */}
          <NavLink
            to="/"
            className="navbar-brand d-flex align-items-center gap-2"
          >
            <img
              src="/logo.Jpeg"
              alt="Logo"
              height="45"
              width="60"
              className="img-fluid"
            />

            <span className="fw-bold fs-5 d-none d-sm-inline">
              <span style={{ color: "var(--color-success)" }}>
                Hindustan Fruits & Veg
              </span>
              <span style={{ color: "var(--color-warning)" }}>.</span>
            </span>
          </NavLink>

          {/* TOGGLER */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarIndian"
            aria-controls="navbarIndian"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* NAV LINKS */}
          <div className="collapse navbar-collapse" id="navbarIndian">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0 fw-semibold text-center">

              <li className="nav-item">
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    `nav-link px-4 ${isActive ? "active-nav" : ""}`
                  }
                >
                  Home
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/produce"
                  className={({ isActive }) =>
                    `nav-link px-4 ${isActive ? "active-nav" : ""}`
                  }
                >
                  Product
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/about"
                  className={({ isActive }) =>
                    `nav-link px-4 ${isActive ? "active-nav" : ""}`
                  }
                >
                  About Us
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/contactus"
                  className={({ isActive }) =>
                    `nav-link px-4 ${isActive ? "active-nav" : ""}`
                  }
                >
                  Contact Us
                </NavLink>
              </li>
            </ul>

            {/* CTA BUTTON */}
            <div className="text-center mt-3 mt-lg-0">
              <button
                onClick={() => setShowModal(true)}
                className="btn px-4 py-2 fw-semibold"
                style={{
                  backgroundColor: "var(--color-success)",
                  color: "#fff",
                  borderRadius: "50px",
                }}
              >
                Enquiry Now
              </button>
            </div>

          

          
          </div>
        </div>

        {/* CUSTOM STYLES */}
        <style>{`
          .nav-link {
            color: var(--color-text-primary);
            transition: all 0.3s ease;
          }

          .nav-link:hover {
            color: var(--color-success);
          }

          .active-nav {
            color: var(--color-success) !important;
            font-weight: 600;
          }

          .navbar-toggler:focus {
            box-shadow: none;
          }
        `}</style>
      </nav>
      <EnquiryModal
              isOpen={showModal}
              onClose={() => setShowModal(false)}
            />
    </>
  );
};

export default Header;
